import { FamilyRestroom, TranslateOutlined } from "@mui/icons-material";

export const questionsConfig = {
  substitution_de_matiere_grasse: [
    {
      id: 1,
      text: "dashboard.decision-tree.fat-sub-filter.qst1",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "Carbohydrates",
          value: [
            "Glucides",
            "Polysaccharides",
            "Glucides/Glucides-Amidon (Chimiquement modifié)",
            "Glucides/Amidon (Chimiquement modifié)",
            "Glucides-Polysaccharides",
            "Glucides-Polysaccharides/Lipides",
            "Glucides-Celluloses",
            "Glucides-Polysaccharides/Amidon",
            "Glucides non digestibles",
            "Glucides-Amidon",
            "Glucides-Polysaccharides/Glucides-Amidon (Chemiquement modifié)",
          ],
          translationKey: "carbohydrates"
        },
        {
          label: "Other natural sources",
          value: [
            "Lipides/Bactéries lactiques",
            "Polysaccharides/Lipides",
            "Lipides/Protéines",
            "Polysaccharides/Microorganismes",
            "Polysaccharides/Protéines",
            "Lipides/Glucides-Polysaccharides",
            "Polysaccharides/Enzymes",
            "Protéines/Glucides",
          ],
          translationKey: "other"
        },
        {
          label: "Proteins",
          value: ["Protéines"],
          translationKey: "proteins",
        },
        {
          label: "Lipids",
          value: ["Lipides"],
          translationKey: "lipids",
        },
        {
          label: "Polyols",
          value: ["Polyols"],
        },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.fat-sub-filter.qst2",
      field: "stabilityTemperatureStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.fat-sub-filter.qst3",
      field: "solubilityCategory",
      requiresDropdown: true,
      isComplexFilter: false,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.fat-sub-filter.qst4",
      isComplexFilter: true,
      properties: [
        "Melting properties positive",
        "Melting properties improvement (x times)",
      ],
      propertyFields: [
        "effParameterStandardize6",
        "effParameterStandardize7",
        "effParameter8",
        "effParameter9",
      ],
      valueFields: ["efficacy6", "efficacy7", "efficacy8", "efficacy9"],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: [
            { min: Infinity, max: -47.7 },
            { min: Infinity, max: -0.25 },
          ],
          label: "Faible",
          translationKey: "low",
        },
        {
          value: [
            { min: -47.7, max: -32.9 },
            { min: -0.25, max: -0.16 },
          ],
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: [
            { min: -32.9, max: Infinity },
            { min: -0.16, max: Infinity },
          ],
          label: "Élevée",
          translationKey: "high",
        },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.fat-sub-filter.qst5",
      isComplexFilter: true,
      properties: [
        "Texture sensory change  (x times)",
        "Texture hardness/firmness change (%) positive",
        "Texture hardness/firmness change (%) negative",
        "Texture chewiness change (%) positive",
        "Texture chewiness change (%) negative",
        "Texture cohesiveness change (%) positive",
        "Consistency change (%)",
      ],
      propertyFields: [
        "effParameter1",
        "effParameter2",
        "effParameter3",
        "effParameter6",
        "effParameter7",
        "effParameter8",
        "effParameter9",
      ],
      valueFields: [
        "efficacy1",
        "efficacy2",
        "efficacy3",
        "efficacy6",
        "efficacy7",
        "efficacy8",
        "efficacy9",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: [
            { min: Number.NEGATIVE_INFINITY, max: -6 },
            { min: Number.NEGATIVE_INFINITY, max: -21.35 },
            { min: 231.5, max: Infinity },
            { min: Number.NEGATIVE_INFINITY, max: -5.79 },
            { min: 87.35, max: Infinity },
            { min: Number.NEGATIVE_INFINITY, max: -51.83 },
            { min: Number.NEGATIVE_INFINITY, max: 0.39 },
          ],
          label: "Faible",
          translationKey: "low",
        },
        {
          value: [
            { min: -5.88, max: 2.46 },
            { min: -21.35, max: 35.61 },
            { min: 163.01, max: 231.5 },
            { min: -5.79, max: 68.93 },
            { min: 56.93, max: 87.35 },
            { min: -51.83, max: -35.36 },
            { min: 0.39, max: 70.27 },
          ],
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: [
            { min: 3, max: Infinity },
            { min: 35, max: Infinity },
            { min: Number.NEGATIVE_INFINITY, max: 163.01 },
            { min: 68.93, max: Infinity },
            { min: Number.NEGATIVE_INFINITY, max: 56.93 },
            { min: 35.36, max: Infinity },
            { min: 70.27, max: Infinity },
          ],
          label: "Favorable",
          translationKey: "favorable",
        },
      ],
    },
    {
      id: 6,
      text: "dashboard.decision-tree.fat-sub-filter.qst6",
      isComplexFilter: true,
      properties: [
        "Acceptability sensory change (x times)",
        "Taste/Flavor sensory change (x times)",
        "Aroma/Smell change (x times)",
      ],
      propertyFields: [
        "effParameter1",
        "effParameter2",
        "effParameter3",
        "effParameter6",
        "effParameter9",
      ],
      valueFields: [
        "efficacy1",
        "efficacy2",
        "efficacy3",
        "efficacy6",
        "efficacy9",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: [
            { min: -2.88, max: Infinity },
            { min: -9, max: Infinity },
            { min: -4.89, max: Infinity },
          ],
          label: "Faible",
          translationKey: "low",
        },
        {
          value: [
            { min: -6.04, max: -2.88 },
            { min: -14.73, max: -9 },
            { min: -10, max: -4.89 },
          ],
          label: "Moyen",
          translationKey: "moderate",
        },
        {
          value: [
            { min: Number.NEGATIVE_INFINITY, max: -6.04 },
            { min: Number.NEGATIVE_INFINITY, max: -14.73 },
            { min: Number.NEGATIVE_INFINITY, max: -10 },
          ],
          label: "Favorable",
          translationKey: "favorable",
        },
      ],
    },
    {
      id: 7,
      text: "dashboard.decision-tree.fat-sub-filter.qst7",
      field: "highQuantity",
      requiresDropdown: true,
      isComplexFilter: false,
      isFilterByOccurrence: false,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: { min: 0.025, max: 4 },
          label: "Très faible",
          translationKey: "very_low",
        },
        {
          value: { min: 4, max: 10 },
          label: "Faible",
          translationKey: "low",
        },
        {
          value: { min: 10, max: 30 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 30, max: 50 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: 50, max: Infinity },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
    {
      id: 8,
      text: "dashboard.decision-tree.fat-sub-filter.qst8",
      isComplexFilter: false,
      isFilterByOccurrence: true,
      valueFields: [
        "efficacity1Level",
        "efficacity2Level",
        "efficacity3Level",
        "efficacity4Level",
        "efficacity5Level",
        "efficacity6Level",
        "efficacity7Level",
        "efficacity8Level",
        "efficacity9Level",
        "efficacity10Level",
        "efficacity11Level",
        "efficacity12Level",
        "efficacity13Level",
        "efficacity14Level",
        "efficacity15Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: [1, 2], label: "Faible", translationKey: "low" },
        { value: [3, 4], label: "Modérée", translationKey: "moderate" },
        { value: [4, 5], label: "Élevée", translationKey: "high" },
      ],
    },
  ],
  selection_des_antimicrobiens: [
    {
      id: 1,
      text: "dashboard.decision-tree.anti-microbial-filter.qst0",
      field: "sourceCategory",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          // value: "Autres sources naturelles",
          label: "Autres sources naturelles",
          value: [
            "Algue, poisson et autres/Plante",
            "Algue, poisson et autres",
            "Animale/Microbienne",
            "Animale/Plante",
            "Autres sources naturelles",
            "Microbienne/Plante",
            "Plante/Autres sources naturelles",
          ],
        },
        {
          //value: "Animale",
          label: "Animal",
          value: ["Animale"],
          translationKey: "animal",
        },
        {
          //value: "Enzyme",
          label: "Enzyme",
          value: ["Enzyme"],
        },
        {
          // value: "Microbienne",
          label: "Microbial",
          value: ["Microbienne"],
          translationKey: "microbial",
        },
        {
          //value: "Plante",
          label: "Plant",
          value: ["Plante"],
          translationKey: "plant",
        },
        {
          //value: "Produit laitier",
          label: "Dairy product",
          value: ["Produit laitier"],
          translationKey: "dairy_product",
        },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.anti-microbial-filter.qst1",
      field: "stabilityTemperatureStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.anti-microbial-filter.qst2",
      field: "stabilityPhStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.anti-microbial-filter.qst3",
      field: "efficacy1Level",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: 1, label: "Faible", translationKey: "low" },
        {
          value: 2,
          label: "Relativement faible",
          translationKey: "relative_low",
        },
        { value: 3, label: "Modérée", translationKey: "moderate" },
        {
          value: 4,
          label: "Relativement élevé",
          translationKey: "relative_high",
        },
        { value: 5, label: "Élevé", translationKey: "high" },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.anti-microbial-filter.qst4",
      field: "optimalQuantity",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: { min: 0.00001, max: 0.001 },
          label: "Très faible",
          translationKey: "very_low",
        },
        {
          value: { min: 0.001, max: 0.1 },
          label: "Faible",
          translationKey: "low",
        },
        {
          value: { min: 0.1, max: 1 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 1, max: 20 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: 20, max: Infinity },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
    // {
    //   id: 6,
    //   text: "dashboard.decision-tree.anti-microbial-filter.qst5",
    //   field: "antimicrobial-flavor-composed",
    //   requiresDropdown: true,
    //   answer: null,
    //   showDropdown: false,
    //   isExpanded: true,
    //   hasFetchableOptions: false,
    //   options: [
    //     { value: "Yes", label: "Yes", translationKey: "yes" },
    //     { value: "No", label: "No", translationKey: "no" },
    //   ],
    // },
  ],
  substitution_des_sucres: [
    {
      id: 1,
      text: "dashboard.decision-tree.sugar-filter.qst1",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.sugar-filter.qst2",
      field: "stabilityPhStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.sugar-filter.qst3",
      field: "stabilityTemperatureStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.sugar-filter.qst4",
      isComplexFilter: true,
      properties: ["Hardness", "Texture"],
      propertyFields: [
        "efficacy1UniformParameter",
        "efficacy2UniformParameter",
        "efficacy3UniformParameter",
        "efficacy4UniformParameter",
        "efficacy5UniformParameter",
        "efficacy6UniformParameter",
      ],
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
        "efficacy6Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: 1, label: "Faible", translationKey: "low" },
        {
          value: 2,
          label: "Relativement faible",
          translationKey: "relative_low",
        },
        { value: 3, label: "Moyen", translationKey: "moderate" },
        {
          value: 4,
          label: "Relativement élevé",
          translationKey: "relative_high",
        },
        { value: 5, label: "Élevé", translationKey: "high" },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.sugar-filter.qst5",
      isComplexFilter: true,
      properties: ["Color / Appearance"],
      propertyFields: [
        "efficacy1UniformParameter",
        "efficacy2UniformParameter",
        "efficacy3UniformParameter",
        "efficacy4UniformParameter",
        "efficacy5UniformParameter",
        "efficacy6UniformParameter",
      ],
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
        "efficacy6Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: 1, label: "Faible", translationKey: "low" },
        {
          value: 2,
          label: "Relativement faible",
          translationKey: "relative_low",
        },
        { value: 3, label: "Moyen", translationKey: "moderate" },
        {
          value: 4,
          label: "Relativement élevé",
          translationKey: "relative_high",
        },
        { value: 5, label: "Élevé", translationKey: "high" },
      ],
    },
    {
      id: 6,
      text: "dashboard.decision-tree.sugar-filter.qst6",
      isComplexFilter: true,
      properties: ["Flavour / Taste"],
      propertyFields: [
        "efficacy1UniformParameter",
        "efficacy2UniformParameter",
        "efficacy3UniformParameter",
        "efficacy4UniformParameter",
        "efficacy5UniformParameter",
        "efficacy6UniformParameter",
      ],
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
        "efficacy6Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: 1, label: "Faible", translationKey: "low" },
        {
          value: 2,
          label: "Relativement faible",
          translationKey: "relative_low",
        },
        { value: 3, label: "Modérée", translationKey: "moderate" },
        {
          value: 4,
          label: "Relativement élevé",
          translationKey: "relative_high",
        },
        { value: 5, label: "Élevé", translationKey: "high" },
      ],
    },
    {
      id: 7,
      text: "dashboard.decision-tree.sugar-filter.qst7",
      field: "optimalQuantity",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: { min: 0.002, max: 1 },
          label: "Très faible",
          translationKey: "very_low",
        },
        { value: { min: 1, max: 30 }, label: "Faible", translationKey: "low" },
        {
          value: { min: 30, max: 100 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 300, max: Infinity },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: 20, max: Infinity },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
    {
      id: 8,
      text: "dashboard.decision-tree.sugar-filter.qst8",
      isFilterByOccurrence: true,
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
        "efficacy6Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: [1, 2], label: "Faible", translationKey: "low" },
        { value: [3, 4], label: "Modérée", translationKey: "moderate" },
        { value: [4, 5], label: "Élevée", translationKey: "high" },
      ],
    },
  ],
  selection_des_antioxydants: [
    {
      id: 1,
      text: "dashboard.decision-tree.antioxidant-filter.qst1",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: ["Glucides", "Fibres"], label: "Glucides" },
        { value: ["Protéines", "Protéine-AA", "Peptides"], label: "Protéines" },
        { value: ["Acide organique"], label: "Acide organique" },
        { value: ["Huile Essentielle"], label: "Huile Essentielle" },
        { value: ["Tocophérol"], label: "Tocophérol" },
        { value: ["Caroténoides"], label: "Caroténoides" },
        { value: ["Lipides"], label: "Lipides" },
        { value: ["Phénols", "Anthocyanines"], label: "Polphénoles" },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.antioxidant-filter.qst2",
      field: "solubilityCategory",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.antioxidant-filter.qst3",
      field: "stabilityPhStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.antioxidant-filter.qst4",
      field: "filtered-combinations-antioxidant-filter-efficacity",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: 1, label: "Faible", translationKey: "low" },
        {
          value: 2,
          label: "Relativement faible",
          translationKey: "relative_low",
        },
        { value: 3, label: "Moyen", translationKey: "moderate" },
        {
          value: 4,
          label: "Relativement élevé",
          translationKey: "relative_high",
        },
        { value: 5, label: "Élevé", translationKey: "high" },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.antioxidant-filter.qst5",
      field: "optimalQuantity",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: { min: 0.0000023, max: 4 },
          label: "Très faible",
          translationKey: "very_low",
        },
        { value: { min: 5, max: 50 }, label: "Faible", translationKey: "low" },
        {
          value: { min: 50, max: 200 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 200, max: 1000 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: 1000, max: Infinity },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
    // {
    //   id: 6,
    //   text: "dashboard.decision-tree.antioxidant-filter.qst6",
    //   field: "antimicrobial-flavor-composed",
    //   requiresDropdown: true,
    //   answer: null,
    //   showDropdown: false,
    //   isExpanded: true,
    //   hasFetchableOptions: false,
    //   options: [
    //     { value: "Yes", label: "Yes", translationKey: "yes" },
    //     { value: "No", label: "No", translationKey: "no" },
    //   ],
    // },
  ],
  // ------- Options Values NEEDS to be Checked ------- //
  selection_des_emulsifiants: [
    {
      id: 1,
      text: "dashboard.decision-tree.emulsifiants-filter.qst1",
      field: "technofunctionality",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: ["Agent emulsifiant"],
          label: "Emulsifying agent",
          translationKey: "emulsifyingAgent",
        },
        {
          value: ["Agent emulsifiant/Stabilisateur d'emulsion"],
          label: "Emulsifier / emulsion stabilizer",
          translationKey: "emulsifying_stabilizer",
        },
        {
          value: ["Stabilisateur d'emulsion"],
          label: "Emulsion stabilizer",
          translationKey: "emulsion_stabilizer",
        },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.emulsifiants-filter.qst2",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "Carbohydrates",
          value: [
            "Carbohydrate-Polysaccharides",
            "Carbohydrates",
            "Carbohydrates-Starch",
          ],
          translationKey: "carbohydrates"
        },
        {
          label: "Other natural sources",
          value: [
            "Carbohydrates/Lipids",
            "Carbohydrates/Lipids/Proteins",
            "Carbohydrates/Phenols",
            "Carbohydrates/Proteins/Phenols",
            "Carbohydrates/Proteins/Saponins",
            "Carbohydrates/Saponins",
            "Lipids/Proteins",
            "Lipids/Saponins",
            "Peptides",
            "Phenols/Proteins",
            "Phenols/Saponins",
            "Proteins/Carbohydrates",
            "Proteins/Saponins",
          ],
          translationKey: "other"
        },
        {
          label: "Glycerides",
          value: ["Glycerides"],
          translationKey: "glycerides"
        },
        {
          label: "Glycolipids",
          value: ["Glycolipids"],
          translationKey: "glycolipids",
        },
        {
          label: "Glycoproteins",
          value: ["Glycoproteins"],
          translationKey: "glycoproteins"
        },
        {
          label: "Lipids",
          value: ["Lipids"],
          translationKey: "lipids"
        },
        {
          label: "Proteins",
          value: ["Proteins"],
          translationKey: "proteins"
        },
        {
          label: "Saponins",
          value: ["Saponins"],
          translationKey: "saponins"
        },
      ],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.emulsifiants-filter.qst3",
      field: "solubilityCategory",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "diluted acid/Water",
          value: [
            "Acide dilue/Eau",
            "Acide dilue/Eau/ND",
            "ND/Acide dilue/Eau",
            "Eau/Acide dilue/Eau",
            "ND/Eau/Acide dilue",
          ],
        },
        {
          label: "Water",
          value: [
            "Eau",
            "Eau/Eau",
            "Eau/Eau/ND",
            "Eau/ND",
            "Eau/ND/ND",
            "ND/Eau",
            "ND/Eau/ND",
          ],
        },
        {
          label: "ND",
          value: ["ND"],
        },
        {
          label: "Insoluble in water",
          value: [
            "Eau/Insoluble dans le Eau",
            "Insoluble dans le Eau/Soluble dans un milieu gras/Soluble dans l'huile",
            "Insoluble dans le Eau/Soluble dans un milieu gras/Soluble dans l'huile/ND",
          ],
        },
        {
          label: "soluble in oil",
          value: ["Soluble dans l'huile"],
        },
        {
          label: "Very soluble in water",
          value: ["Très Soluble dans l'Eau"],
        },
      ],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.emulsifiants-filter.qst4",
      field: "phStability",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "Acid",
          value: ["Acid pH stable"],
        },
        {
          label: "Acid/Neutral",
          value: ["Acid-Neutral pH stable"],
        },
        {
          label: "Full pH stable",
          value: ["Acid-Neutral-Basic pH stable", "Full pH stable"],
        },
        {
          label: "Neutral",
          value: ["Neutral pH stable"],
        },
        {
          label: "Neutral-Basic pH stable",
          value: ["Neutral-Basic pH stable"],
        },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.emulsifiants-filter.qst5",
      field: "heatStability",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "High",
          value: ["High temperature stable"],
        },
        {
          label: "Low",
          value: ["Low temperature stable"],
        },
        {
          label: "Low/High",
          value: ["Low-High temperature stable"],
        },
        {
          label: "Low/Moderate",
          value: ["Low-Moderate stable", "Low-Moderate temperature stable"],
        },
        {
          label: "Low/Moderate/High",
          value: [
            "Low-Moderate-High temperature Stable",
            "Low-Moderate-High temperature stable",
          ],
        },
        {
          label: "Moderate",
          value: ["Moderate stable", "Moderate temperature stable"],
        },
        {
          label: "Moderate/High",
          value: ["Moderate-High temperature stable"],
        },
        {
          label: "Unstable",
          value: ["Unstable"],
        },
      ],
    },
    {
      id: 6,
      text: "dashboard.decision-tree.emulsifiants-filter.qst6",
      isComplexFilter: false,
      isFilterByOccurrence: true,
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
      ],
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        { value: [1, 2], label: "Faible", translationKey: "low" },
        { value: [3, 4], label: "Modérée", translationKey: "moderate" },
        { value: [4, 5], label: "Élevée", translationKey: "high" },
      ],
    },
    {
      id: 7,
      text: "dashboard.decision-tree.emulsifiants-filter.qst7",
      field: "optimalQuantity",
      requiresDropdown: true,
      options: [
        {
          value: { min: 0.0008, max: 0.5 },
          label: "Très faible",
          translationKey: "very_low",
        },
        { value: { min: 0.5, max: 5 }, label: "Faible", translationKey: "low" },
        {
          value: { min: 5, max: 10 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 10, max: 30 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: Infinity, max: 30 },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
  ],
  selection_des_moussants: [
    {
      id: 1,
      text: "dashboard.decision-tree.moussants-filter.qst1",
      field: "technofunctionality",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: ["Agent moussant"],
          label: "Foaming agent",
          translationKey: "foaming_agent",
        },
        {
          value: ["Agent moussant/Stabilisateur de mousse"],
          label: "Foaming / Foam stabilizer",
          translationKey: "foaming_stabilizer",
        },
        {
          value: ["Stabilisateur de mousse"],
          label: "Foam stabilizer",
          translationKey: "foam_stabilizer",
        },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.moussants-filter.qst2",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: ["Lipids"],
          label: "Lipids",
          translationKey: "lipids",
        },
        {
          value: [
            "Carbohydrates",
            "Carbohydrates–Pectins",
            "Carbohydrates–Polysaccharides",
            "Carbohydrates–Starch (physically modified)",
          ],
          label: "Carbohydrates",
          translationKey: "carbohydrates",
        },
        {
          value: ["Protein"],
          label: "Proteins",
          translationKey: "proteins",
        },
        {
          value: [
            "Protein/Carbohydrate",
            "Protein/Carbohydrate–Polysaccharide",
            "Protein/Carbohydrate–Polysaccharide/Lip",
            "Protein/Carbohydrate–Polysaccharide/Lipids",
            "Protein/Lipids",
            "Protein/Phenol",
            "Protein/Polyphenols",
            "Protein/Polyphenols/Carbohydrates–Starch",
            "Protein/Polyphenols/Carbohydrates-Starch (Chemically modified)",
            "Protein/Saponins",
            "Proteins/Carbohydrates",
            "Proteins/Carbohydrates/Lipids",
            "Proteins/Carbohydrates–Polysaccharides",
            "Proteins/Carbohydrates–Polysaccharides/Lipids",
            "Proteins/Carbohydrates–Starch (physically modified)",
            "Saponins/Lipids",
          ],
            label: "Other natural sources",
            translationKey: "other",
        },
        {
          value: ["Saponins"],
          label: "Saponins",
          translationKey: "saponins",
        },
      ],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.moussants-filter.qst3",
      field: "solubilityCategory",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [
        {
          value: ["Eau"],
          label: "Water",
        },
        {
          value: ["Acidique"],
          label: "Acidique/Acid",
        },
        {
          value: ["Acidique/Eau"],
          label: "Acidique/Water",
        },
        {
          value: [
            "Insoluble dans Eau",
            "Insoluble dans l'Eau",
            "Insoluble dans l'eau",
          ],
          label: "Insoluble dans l'Eau",
          translationKey: "not_soluble_water",
        },
      ],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.moussants-filter.qst4",
      field: "stabilityPhStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [
        {
          value: ["Acidique"],
          label: "Acid",
          translationKey: "acid",
        },

        {
          value: ["Neutre"],
          label: "Neutral",
          translationKey: "neutral",
        },
        {
          value: ["Acidique/Basique"],
          label: "Acidic/Base",
          translationKey: "acidic_base",
        },
        {
          value: ["Acidique/Neutre/Basique"],
          label: "Acidic/Neutral/Basic",
          translationKey: "acidic_neutral_base",
        },
        {
          value: ["Acidique/Neutre"],
          label: "Acidic/Neutral",
        },
        {
          value: ["Neutre/Basique"],
          label: "Neutral/Basic",
        },
        {
          value: ["Basique"],
          label: "Basic",
          translationKey: "base",
        },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.moussants-filter.qst5",
      field: "stabilityTemperatureStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 6,
      text: "dashboard.decision-tree.moussants-filter.qst6",
      isFilterByOccurrence: true,
      valueFields: ["efficacy1Classification", "efficacy2Classification"],
      requiresDropdown: true,
      options: [
        { value: [1, 2], label: "Faible", translationKey: "low" },
        { value: [3, 3], label: "Modérée", translationKey: "moderate" },
        { value: [4, 5], label: "Élevée", translationKey: "high" },
      ],
    },
    {
      id: 7,
      text: "dashboard.decision-tree.moussants-filter.qst7",
      field: "optimalQuantity",
      requiresDropdown: true,
      options: [
        {
          value: { min: 0.005, max: 1 },
          label: "Très faible",
          translationKey: "very_low",
        },
        {
          value: { min: 1, max: 5 },
          label: "Faible",
          translationKey: "low",
        },
        {
          value: { min: 5, max: 10 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 10, max: 50 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: 50, max: Infinity },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
  ],
  selection_des_epaississants: [
    {
      id: 1,
      text: "dashboard.decision-tree.epaississants-filter.qst1",
      field: "technofunctionality",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: ["Agent gelifiant"],
          label: "Gelling agent",
          translationKey: "gelling_agent",
        },
        {
          value: ["Agent epaississant"],
          label: "Thickener",
          translationKey: "thickener",
        },
        {
          value: ["Agent gelifiant/Epaississant"],
          label: "Gelling / Thickening agent",
          translationKey: "gelling_thickener",
        },
      ],
    },
    {
      id: 2,
      text: "dashboard.decision-tree.epaississants-filter.qst2",
      field: "chemicalCompositionStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          value: [
            "Carbohydrates",
            "Carbohydrates–Cellulose",
            "Carbohydrates–Galactan",
            "Carbohydrates–Galactomannan",
            "Carbohydrates–Glucan",
            "Carbohydrates–Glucomannan",
            "Carbohydrates–Pectin and Starch",
            "Carbohydrates–Pectins",
            "Carbohydrates–Pectins/Polysaccharides",
            "Carbohydrates–Polysaccharides",
            "Carbohydrates–Polysaccharides/Glycoproteins",
            "Carbohydrates–Polysaccharides/Starch",
            "Carbohydrates–Starch",
            "Carbohydrates–Starch (chemically modified)",
            "Carbohydrates–Starch (physically modified)",
            "Carbohydrates–Pectins/Polysaccharides",
            "Polysaccharides",
            "Polysaccharides/Galactose",
          ],
          label: "Carbohydrates",
          translationKey: "carbohydrates",
        },
        {
          value: ["Proteins", "Proteins/AA"],
          label: "Proteins",
          translationKey: "proteins",
        },
        {
          label: "Autres sources naturelles / Other natural sources",
          value: [
            "Carbohydrates–Polysaccharides/Proteins",
            "Carbohydrates–Semi synthesized Celluloses",
            "Carbohydrates–Starch and others",
            "Carbohydrates–Starch/Protein",
            "ND",
            "Proteins/Carbohydrates",
            "Proteins/Carbohydrates–Pectins",
            "Proteins/Carbohydrates–Polysaccharides",
            "Proteins/Phenols",
          ],
        },
        {
          label: "Glycoprotéines / Glycoproteins",
          value: ["Glycoproteins"],
        },
        {
          label: "Polymères/polymers",
          value: ["Polymers"],
        },
      ],
    },
    {
      id: 3,
      text: "dashboard.decision-tree.epaississants-filter.qst3",
      field: "solubilityCategory",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [],
    },
    {
      id: 4,
      text: "dashboard.decision-tree.epaississants-filter.qst4",
      field: "stabilityPhStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: true,
      options: [
        {
          value: ["Acidique"],
          label: "Acid",
          translationKey: "acid",
        },
        {
          value: ["Acidique/Basique"],
          label: "Acid/Base",
        },
        {
          value: ["Basique"],
          label: "Base",
          translationKey: "base",
        },
        {
          value: ["Neutre"],
          label: "Neutral",
          translationKey: "neutral",
        },
        {
          value: ["Acidique/Neutre"],
          label: "Acid/Neutral",
        },
        {
          value: ["Neutre/Basique"],
          label: "Neutral/Base",
        },
      ],
    },
    {
      id: 5,
      text: "dashboard.decision-tree.epaississants-filter.qst5",
      field: "stabilityTemperatureStandardized",
      requiresDropdown: true,
      answer: null,
      showDropdown: false,
      isExpanded: true,
      hasFetchableOptions: false,
      options: [
        {
          label: "Ambient",
          value: ["Ambiante"],
        },
        {
          label: "Ambient/High",
          value: ["Ambiante; élevée", "Ambiante; élevée, très élevée"],
        },
        {
          label: "Refrigerated / Freezing",
          value: ["Congélation ; Réfrigérée"],
        },
        {
          label: "High",
          value: ["Élevée"],
        },
        {
          label: "High/Very high",
          value: ["Élevée ; Très élevée", "Très élevée"],
        },
        {
          label: "Low",
          value: ["Faible"],
        },
        {
          label: "Variable",
          value: ["Faible (pH 4-9); Très élevé (pH >10.0)"],
        },
        {
          label: "Large interval",
          value: [
            "Faible ; ambiante ; élevée",
            "Large interval",
            "No gelation in 25-130 C",
            "Réfrigérée; Faible ; Ambiante",
            "Réfrigérée; Faible ; Ambiante; élevée",
            "Réfrigérée; Faible ; Ambiante; élevée; très élevée",
          ],
        },
        {
          label: "Refrigerated",
          value: ["Réfrigérée"],
        },
        {
          label: "Refrigerated/Low/Ambient",
          value: ["Réfrigérée; Faible ; Ambiante"],
        },
      ],
    },
    {
      id: 6,
      text: "dashboard.decision-tree.epaississants-filter.qst6",
      valueFields: [
        "efficacy1Level",
        "efficacy2Level",
        "efficacy3Level",
        "efficacy4Level",
        "efficacy5Level",
        "efficacy6Level",
      ],
      requiresDropdown: true,
      isFilterByOccurrence: true,
      options: [
        { value: [1, 2], label: "Faible", translationKey: "low" },
        { value: [3, 4], label: "Moyen", translationKey: "moderate" },
        { value: [4, 5], label: "Élevée", translationKey: "high" },
      ],
    },
    {
      id: 7,
      text: "dashboard.decision-tree.epaississants-filter.qst7",
      field: "optimalConcentration",
      requiresDropdown: true,
      options: [
        { value: ["ND"], label: "Not mentioned" },
        {
          value: { min: 0.00055, max: 1 },
          label: "Très faible",
          translationKey: "very_low",
        },
        {
          value: { min: 1, max: 5 },
          label: "Faible",
          translationKey: "low",
        },
        {
          value: { min: 5, max: 10 },
          label: "Modérée",
          translationKey: "moderate",
        },
        {
          value: { min: 10, max: 40 },
          label: "Élevée",
          translationKey: "high",
        },
        {
          value: { min: Infinity, max: 40 },
          label: "Très  Elevée",
          translationKey: "very_high",
        },
      ],
    },
  ],
};
